import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="share"
export default class extends Controller {
  static values = { url: String, title: String, copiedLabel: String }
  static targets = ["label", "icon"]

  async share() {
    if (navigator.share) {
      try {
        await navigator.share({ title: this.titleValue, url: this.urlValue })
      } catch (error) {
        if (error.name !== "AbortError") {
          this.copy()
        }
      }
      return
    }

    this.copy()
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = this.urlValue
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }
    this.showCopied()
  }

  showCopied() {
    const originalIcon = this.hasIconTarget ? this.iconTarget.innerHTML : null
    const originalLabel = this.hasLabelTarget ? this.labelTarget.textContent : null

    if (this.hasIconTarget) {
      this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5" />'
    }
    if (this.hasLabelTarget && this.copiedLabelValue) {
      this.labelTarget.textContent = this.copiedLabelValue
    }

    setTimeout(() => {
      if (this.hasIconTarget && originalIcon !== null) {
        this.iconTarget.innerHTML = originalIcon
      }
      if (this.hasLabelTarget && originalLabel !== null) {
        this.labelTarget.textContent = originalLabel
      }
    }, 2000)
  }
}
